// src/Pages/About.js
import React from 'react';
import SEO from '../components/SEO';


function About() {
  return (
    <div>

      <SEO 
        title="About - My Website" 
        description="Welcome to my website homepage"
      />

      <h1>About Page</h1>
      <p>This is the about page.</p>
    </div>
  );
}

export default About;